import type {
	AIResponsePayload,
	TranscriptTurn,
} from "@memorang/types/src/session/new-session";

import type { SummativeResult, TranscriptMessage } from "../types";
import { buildSimulationTranscript } from "./transcript";

type ReflectSkill = { name: string; max?: number };

/**
 * Assemble the persisted AI-response for a completed simulation: summative
 * (feedback + per-criterion scores + thread id) plus the structured transcript.
 * The legacy joined `answer` string is intentionally omitted for sims.
 */
export const buildSimulationAiResponse = ({
	summative,
	reflectSkills,
	threadId,
	transcript,
}: {
	summative?: Partial<SummativeResult>;
	reflectSkills: ReflectSkill[];
	threadId?: string | null;
	transcript: TranscriptMessage[];
}): AIResponsePayload => {
	const subskillAssessments = (summative?.criteria ?? []).map((criterion) => ({
		name: criterion.name,
		score: criterion.score,
		maxScore:
			reflectSkills.find((skill) => skill.name === criterion.name)?.max ?? 4,
		reason: criterion.reason,
	}));

	const transcriptTurns: TranscriptTurn[] =
		buildSimulationTranscript(transcript);

	return {
		feedback: summative?.feedback ?? "",
		subskillAssessments,
		ai_run_id: "",
		ai_thread_id: threadId ?? "",
		metadata: { assistantId: "" },
		transcript: transcriptTurns,
	};
};
